import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AdminLayout } from '../AdminLayout';
import { useSelector } from 'react-redux';
import { selectUser } from 'app/slice/selectors';

interface Props {}

export function ProtectedRoute(props: Props) {
  const user = useSelector(selectUser);
  const [isInitialized, setIsInitialized] = useState(false);
  
  useEffect(() => {
    // Small delay to ensure Redux state is properly initialized
    const timer = setTimeout(() => {
      setIsInitialized(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  const token = localStorage.getItem('api_token');
  const rememberMe = localStorage.getItem('rememberMe') === 'true';
  
  // Don't render anything until initialization is complete
  if (!isInitialized) {
    return null;
  }
  
  // Check if user is authenticated
  const isAuthenticated = (user && token) || (token && rememberMe);
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
